<template>
    <div class="social-preview-toggle">
        <div class="social-preview-toggle__header">
            <div class="social-preview-toggle__title">
                <Icon type="ios-image" class="social-preview-toggle__icon" />
                <span class="social-preview-toggle__label">Social preview</span>
            </div>

            <LabeledSwitch :model-value="modelValue" size="small" @change="onChange" />
        </div>

        <p class="social-preview-toggle__description">
            <template v-if="modelValue">On - previewing your creatives inside a social platform mockup.</template>
            <template v-else> Off - previewing your creatives on their own.</template>
        </p>
    </div>
</template>

<script lang="ts" setup>
import LabeledSwitch from "@/components/Campaign/LabeledSwitch.vue";

defineProps<{
    modelValue: boolean;
}>();

const emit = defineEmits<{
    "update:modelValue": [value: boolean];
}>();

function onChange(value: boolean) {
    emit("update:modelValue", value);
}
</script>

<style lang="scss" scoped>
@use "@style/variables" as *;

.social-preview-toggle {
    border: 1px solid var(--wpp-grey-color-300);
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.social-preview-toggle__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    .labeled-switch {
        flex: 0;
    }
}

.social-preview-toggle__title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.social-preview-toggle__icon {
    color: var(--wpp-primary-color-500);
    font-size: 20px;
}

.social-preview-toggle__label {
    font-weight: 700;
    font-size: 15px;
}

.social-preview-toggle__description {
    margin: 0;
    color: var(--wpp-grey-color-600);
    font-size: 13px;
    line-height: 1.4;
}

body:has(> .wpp-theme-dark) {
    .social-preview-toggle {
        border-color: var(--wpp-grey-color-800);
        background-color: var(--wpp-grey-color-900);
    }

    .social-preview-toggle__label {
        color: var(--wpp-grey-color-100);
    }

    .social-preview-toggle__description {
        color: var(--wpp-grey-color-500);
    }
}
</style>
